/**
 * Created by gengqingqing on 2017/8/4.
 */
const state = {
	tableInfo: null,
	fields: [],
	contact_pages: [],
};

import {
	genNonDuplicateID
} from '../../utils/controlUtils'

const mutations = {
	SELECT_DB_TABLE(state, table) {
		state.tableInfo = table;
	},

	/**
	 * 新增一个字段
	 * @param state
	 * @param field_name
	 * @param name
	 * @param desc
	 * @constructor
	 */
	NEW_FIELD(state, field_name, name, desc) {
		let field = {
			field_name: field_name || '',
			name: name || '',
			desc: desc || '',
			field_id: genNonDuplicateID()
		};
		let existIndex = -1;
		for (let j = 0; j < state.fields.length; j++) {
			let item = state.fields[j];
			if (item.field_name == field_name) {
				break;
			}
			existIndex++;
		}
		if (existIndex == state.fields.length - 1) {
			field.field_id = genNonDuplicateID(i);
			state.fields.push(field);
		}
	},

	/**
	 * 新增字段数组
	 * @param state
	 * @param fields
	 * @constructor
	 */
	NEW_CONTROLS(state, fields) {
		if (fields && fields.length) {
			for (let i = 0; i < fields.length; i++) {
				let field = fields[i];
				let existIndex = -1;
				for (let j = 0; j < state.fields.length; j++) {
					let item = state.fields[j];
					if (item.field_name == field.field_name) {
						break;
					}
					existIndex++;
				}
				if (existIndex == state.fields.length - 1) {
					field.field_id = genNonDuplicateID(i);
					state.fields.push(field);
				}
			}
		}
	}
};

// /**
//  * 生成FIELD_ID
//  * @param index
//  */
// function genFieldId(index = 0) {
// 	return Number(Math.random().toString().substr(3, 7) + Date.now() + index).toString(36);
// };

export default {
	state,
	mutations
}


// WEBPACK FOOTER //
// ./src/vuex/stores/table.js